import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/macro';
import { Heading2Mixin, Footnote } from '@qover/typography';

import HelpIcon from './icons/HelpIcon';

const Container = styled.div`
  text-align: left;
  padding: 20px;
  display: flex;
  color: ${({ theme }) => theme.colors.secondary()};

  & svg {
    flex-shrink: 0;
  }
`;

const Title = styled.div`
  ${Heading2Mixin};
  margin-bottom: 10px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 14px;
`;

export function SupportCenterHeader() {
  return (
    <Container>
      <HelpIcon />
      <Content>
        <Title as="div">
          <Trans id="general.supportCenter.title" />
        </Title>
        <Footnote>
          <span className="bold">
            <Trans id="general.supportCenter.findAnswer" />
          </span>
          &nbsp;
          <Trans id="general.supportCenter.weAreToHelp" />
        </Footnote>
      </Content>
    </Container>
  );
}
